export default __webpack_public_path__ + "static/media/PersonalItem.02d594a0.svg";